import React, { useState } from "react";
import { useParams } from "react-router-dom";
import products from "../data/products.json";
import "./ProductDetails.css";
import Modal from "./Modal";
import { useCart } from "../context/CartContext";
import CustomizationForm from "./CustomizationForm";

function ProductDetails() {
    const [isDeliveryModalOpen, setIsDeliveryModalOpen] = useState(false);  // Modal para formas de entrega
    const [isCustomizationModalOpen, setIsCustomizationModalOpen] = useState(false);  // Modal para personalización
    const [isAccordionOpen, setIsAccordionOpen] = useState({
        domicile: false,
        branch: false,
    });
    const { addItemToCart } = useCart();
    const [quantity, setQuantity] = useState(1); // Estado para la cantidad seleccionada
    const { name } = useParams();  // Obtenemos el 'name' de la URL

    // Busca el producto asegurándote de que el nombre en la URL coincida con el de los productos
    const product = products.find(p =>
        p.name.toLowerCase().replace(/\s+/g, '-').toLowerCase() === name
    );

    // Estado para manejar la imagen principal seleccionada
    const [mainImage, setMainImage] = useState(product?.img);

    // Estado para personalización
    const [customization, setCustomization] = useState({
        colors: "",
        size: "",
        name: "",
        comments: ""
    });

    const handleAddToCart = () => {
        console.log("Agregando al carrito:", product, "Cantidad:", quantity, "Personalización:", customization);
        if (quantity < 1) return;

        const productWithCustomization = {
            ...product,
            quantity, // Producto original
            customization: {
                colors: customization.colors,
                size: customization.size,
                name: customization.name,
                comments: customization.comments,
            },
        };

        // Aquí puedes agregar este objeto al carrito
        addItemToCart(productWithCustomization);
        setIsCustomizationModalOpen(true); // Abre el modal de personalización
    };

    // Si no se encuentra el producto, mostrar un mensaje
    if (!product) {
        return <p>Producto no encontrado.</p>;
    }

    const toggleDeliveryModal = () => {
        setIsDeliveryModalOpen(!isDeliveryModalOpen);
    };

    const toggleCustomizationModal = () => {
        setIsCustomizationModalOpen(!isCustomizationModalOpen);
    };

    const toggleAccordion = (section) => {
        setIsAccordionOpen((prev) => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    const handleWhatsAppRedirect = () => {
        const message = '¡Hola!, quiero solicitar un presupuesto para un diseño personalizado.';
        const encodedMessage = encodeURIComponent(message);
        const phoneNumber = "2236692372";  // Número de WhatsApp al que se redirige
        window.location.href = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    };

    return (
        <>
            <div className="product-details">
                {/* Mostrar imagen del producto */}
                <div className="product-image">
                    <div className="image-gallery">
                        <div className="main-image">
                            <img src={require(`../assets/products/${mainImage}`)} alt={product.name} />
                        </div>
                        {/* Miniaturas */}
                        <div className="thumbnails">
                            {product.images.map((image, index) => (
                                <img
                                    key={index}
                                    src={require(`../assets/products/${image}`)}
                                    alt={`Miniatura ${index + 1}`}
                                    className={`thumbnail ${mainImage === image ? "active" : ""}`}
                                    onClick={() => setMainImage(image)} // Cambiar la imagen principal al hacer clic
                                />
                            ))}
                        </div>

                    </div>
                </div>

                <div className="product-info">
                    <div className="product-details-description">
                        <h1>{product.name}</h1>

                        {/* Lógica para mostrar los precios */}
                        {product.id === 0 ? (
                            <p className="price">A Consultar</p>
                        ) : product.promotions ? (
                            <>
                                <p className="price-new">${product["offer-price"]} c/u</p>
                                <p className="price-old">Antes: ${product.price} c/u</p>
                            </>
                        ) : (
                            <p className="price">${product.price} c/u</p>
                        )}

                        {/* Mostrar botones dependiendo del producto */}
                        {product.id === 0 ? (
                            <button className="whatsapp-button" onClick={handleWhatsAppRedirect}>
                                <i className="fab fa-whatsapp"></i> Ir a WhatsApp
                            </button>
                        ) : (
                            <div className="quantity-selector">
                                <button
                                    type="button"
                                    className="quantity-btn"
                                    onClick={() => setQuantity((prev) => Math.max(prev - 1, 1))} // Reducir cantidad
                                >
                                    -
                                </button>
                                <input
                                    type="number"
                                    className="quantity-input"
                                    value={quantity}
                                    readOnly // Evitar entrada manual
                                />
                                <button
                                    type="button"
                                    className="quantity-btn"
                                    onClick={() => setQuantity((prev) => prev + 1)} // Incrementar cantidad
                                >
                                    +
                                </button>
                            </div>
                        )}

                        <button className="modal-button" onClick={toggleDeliveryModal}>
                            Ver formas de entrega
                        </button>

                        {product.id !== 0 && (
                            <button className="modal-button" onClick={toggleCustomizationModal}>
                                Agregar al carrito
                            </button>
                        )}
                    </div>

                    <Modal isOpen={isDeliveryModalOpen} onClose={toggleDeliveryModal} title="Formas de entrega y tiempos">
                        <ul className="modal-list">
                            <li className="list">
                                <strong>Producción personalizada: </strong>
                                Nuestro proceso de fabricación incluye el diseño personalizado y la impresión, y, según lo solicitado por el cliente, se puede agregar detalles adicionales, como pintado a mano, para lograr un acabado único y exclusivo. El tiempo de producción puede variar según la complejidad del pedido. Nos comunicaremos contigo una vez que tu producto esté listo para coordinar la entrega.
                            </li>
                            <li className="list">
                                <strong>Envíos en Mar del Plata: </strong>
                                Contamos con delivery local en Mar del Plata. Una vez que el producto esté terminado, se entregará en un plazo de 1-2 días hábiles.
                            </li>
                            <li className="list">
                                <strong>Envíos nacionales: </strong>
                                <p>Si estás fuera de Mar del Plata, tu pedido será despachado a través de un servicio de logística.</p>
                                <div className="accordion">
                                    <div className="accordion-item">
                                        <button
                                            className="accordion-button"
                                            onClick={() => toggleAccordion("domicile")}
                                        >
                                            Envío a domicilio
                                        </button>
                                        {isAccordionOpen.domicile && (
                                            <div className="accordion-content">
                                                <p>Recibe tu pedido en la dirección que proporciones. El tiempo estimado de entrega es de 3-5 días hábiles después del despacho, dependiendo de tu ubicación.</p>
                                            </div>
                                        )}
                                    </div>

                                    <div className="accordion-item">
                                        <button
                                            className="accordion-button"
                                            onClick={() => toggleAccordion("branch")}
                                        >
                                            Envío a sucursal
                                        </button>
                                        {isAccordionOpen.branch && (
                                            <div className="accordion-content">
                                                <p>Puedes retirar tu pedido en la sucursal más cercana del servicio de logística. El tiempo estimado de entrega es de 2-4 días hábiles después del despacho.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </li>
                            <li className="list">
                                <strong>Consulta personalizada: </strong>
                                Si tienes preguntas sobre tu pedido, no dudes en contactarnos para obtener una estimación más precisa.
                            </li>
                            <li className="list">
                                <strong>Nota importante: </strong>
                                Los tiempos de envío comienzan a contar una vez que el producto esté terminado. Te notificaremos cuando el pedido sea despachado.
                            </li>
                        </ul>
                    </Modal>
                </div>

                {/* Modal para personalización */}
                <Modal
                    isOpen={isCustomizationModalOpen}
                    onClose={toggleCustomizationModal}
                    title="Personaliza tu producto"
                >
                    <CustomizationForm
                        customization={customization}
                        setCustomization={setCustomization}
                        handleAddToCart={handleAddToCart}
                        closeModal={toggleCustomizationModal}
                        product={product}
                        addItemToCart={addItemToCart}
                        quantity={quantity}
                    />
                </Modal>

            </div >
            <div className="product-description">
                <h2>Descripción del Producto</h2>
                {product.description.map((item, index) => (
                    <div className="description-item" key={index}>
                        <h3>{item.title}</h3>
                        {item.content.split('\n').map((line, lineIndex) => (
                            <p key={lineIndex}>{line}</p>
                        ))}
                    </div>
                ))}
            </div>

        </>
    );
}

export default ProductDetails;
